module.exports = __webpack_public_path__ + "static/media/apartment7.4f827b4f.jpg";